import { FC } from 'react'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
//@ts-expect-error ignore
import ReactJsonViewCompare from 'react-json-view-compare'
import { IndicesRecord } from '@opensearch-project/opensearch/api/_types/cat.indices'

import { ButtonApp, ModalApp } from '@/components'

import { IndexMappingTabContent } from './IndexMappingTabContent'

interface IndexDetailsModalProps {
  index?: IndicesRecord
  isOpen?: boolean
  handleCloseModal(): void
}

const tabListHeaders = ['Details', 'Mappings']

const IndexDetailsModal: FC<IndexDetailsModalProps> = ({
  index,
  isOpen = false,
  handleCloseModal,
}) => {
  if (!index) return null

  return (
    <ModalApp
      isOpenModal={isOpen}
      handleCloseModal={handleCloseModal}
      title="Latest Updates"
      maxHeight="xs:max-h-[820px] md:max-h-[800px]"
      maxWidth="xs:max-w-[340px] md:max-w-xl"
    >
      <div className="w-full flex flex-col min-h-0">
        <div className="p-8 min-h-[60vh] max-h-[60vh] overflow-hidden flex">
          <TabGroup className="grow flex flex-col gap-6 max-w-full">
            <TabList className="flex gap-2 items-baseline border-b border-gray-100 px-8 mx-2">
              {tabListHeaders.map((header, index) => (
                <Tab
                  key={index}
                  className="-mb-[1px] focus-visible:outline-none py-2 px-4 text-gray-500 text-sm rounded-[4px] rounded-b-none border border-gray-100 bg-[#F5F7FA] data-[selected]:bg-white data-[selected]:border-b-white"
                >
                  {header}
                </Tab>
              ))}
            </TabList>
            <TabPanels className="grow overflow-auto px-4">
              <TabPanel className="h-full">
                <pre className="h-full rounded-lg border border-gray-100 p-6 text-gray-500 text-sm overflow-x-auto">
                  {JSON.stringify(index, null, 2)}
                </pre>
              </TabPanel>
              <TabPanel className="h-full">
                <IndexMappingTabContent indexName={index.index!} />
              </TabPanel>
            </TabPanels>
          </TabGroup>
        </div>
        <div className="flex justify-end w-full py-6 px-8 border-t border-[#F0F2F7]">
          <ButtonApp
            handleClick={handleCloseModal}
            isPrimary={false}
            width="md:min-w-[160px] w-fit"
            className="h-12"
          >
            Close
          </ButtonApp>
        </div>
      </div>
    </ModalApp>
  )
}

export { IndexDetailsModal }
